// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"899b9c75","177":"ae11fd24","266":"5a231a36","362":"ca3a57d1","405":"0f654122","453":"8e84fa65","573":"20044f30","699":"c7d9715a","772":"6f879b06","842":"74c02e6e","864":"0cb403e9"}[chunkId] + ".chunk.js";
};